import React, { useEffect } from "react";

// context
import { StoreLocatorProvider } from "../context/Context";

// error handler
import ErrorBoundary from "./errorBoundary/ErrorBoundary";

// theming
import { ThemeProvider } from "styled-components";
import ThemeProviderStyled from "../theme/ThemeProvider.styled";

// pages
import { MainPage } from "../pages/main/MainPage";

// heplers
import { initDataLayer } from "../helpers/helpers";

const App = () => {
	useEffect(() => {
		initDataLayer();
	}, []);

	return (
		<ErrorBoundary>
			<StoreLocatorProvider>
				<ThemeProvider theme={ThemeProviderStyled}>
					<MainPage />
				</ThemeProvider>
			</StoreLocatorProvider>
		</ErrorBoundary>
	);
};

export default App;
